// Dependency types moved to break circular dependencies
// This file contains dependency types that are needed by multiple modules without creating circular dependencies

import type { EntityIconType } from '../Entity/constants';

export enum DependencyTypes {
  maven = 'coordinates',
  pypi = 'pypi',
  custom = 'custom',
  package = 'package',
  plibMaven = 'plibMaven',
  plibPypi = 'plibPypi',
  system = 'system'
}

export interface DependencyType {
  repo?: string;
  id: string;
  entity?: EntityIconType;
  type: DependencyTypes;
  coordinates?: string;
  addToPipeline?: boolean;
  editable?: boolean;
  enabled?: boolean;
  package?: string;
  entityName?: string;
  name: string;
  createdAt?: string;
  modifiedAt?: string;
  description?: string;
  scope?: string;
  version?: string;
  exclusions?: string[];
  __path?: string;
}

export type ProjectDependencyType = DependencyType & {
  directDependency?: boolean;
  latestReleaseVersion?: string;
};
